import React from 'react';
import { Spin, Space, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const LoadingScreen = ({ 
  title = 'Loading Dashboard', 
  message = 'Please wait while we prepare your information',
  fullScreen = true,
  minHeight = '400px'
}) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 40, color: '#1677ff' }} spin />;
  
  const containerStyle = fullScreen ? {
    height: '100vh',
    width: '100%',
  } : {
    height: minHeight,
    width: '100%',
    padding: '20px',
  };
  
  return (
    <div style={{
      ...containerStyle,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f8f9fa',
    }}>
      <div style={{
        padding: '40px',
        borderRadius: '12px',
        backgroundColor: 'white',
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.08)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#f0f5ff',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Spin indicator={antIcon} />
        </div>
        
        <Space direction="vertical" align="center">
          <Text style={{ fontSize: '18px', fontWeight: '600', color: '#262626' }}>
            {title}
          </Text>
          <Text type="secondary" style={{ fontSize: '14px' }}>
            {message}
          </Text>
        </Space>
        
        <div style={{
          width: '180px',
          height: '4px',
          backgroundColor: '#f0f0f0',
          borderRadius: '4px',
          overflow: 'hidden',
          marginTop: '8px',
          position: 'relative',
        }}>
          <div 
            style={{
              position: 'absolute',
              height: '100%',
              width: '50%',
              backgroundColor: '#1677ff',
              borderRadius: '4px',
              animation: 'loading 1.5s infinite',
            }}
          />
        </div>
      </div>
      
    </div>
  );
};

export default LoadingScreen;
